import { Component, Host, h, Prop, Watch } from '@stencil/core';
import { TrackableContentId } from '../../../types/global';

interface UiCmsFundsSelectionBody {
  initialAmountOfFunds: number;
  searchApi: string;
  fundApi: string;
  fundApiKey: string;
  fundSearchLink: RefLink;
  fundPortraitLink: RefLink;
  funds?: string[];
  characteristicsByFacet?: Facet;
  filters?: string[];
  allFundsLabel: string;
  uniqueId: string;
}

interface Facet {
  category?: 'stock' | 'mixed' | 'pension' | 'capitalProtected' | 'realEstateOpenEnd';
  ratingByMorningstar?:
    | 'oneStarsRating'
    | 'twoStarsRating'
    | 'threeStarsRating'
    | 'fourStarsRating'
    | 'fiveStarsRating';
  risk?: 'lowRisk' | 'mediumRisk' | 'heightenedRisk' | 'highRisk';
  sustainability?: boolean;
  savingsPlanFeasibility?: boolean;
}

interface RefLink extends TrackableContentId {
  src: string;
}

@Component({
  tag: 'ui-cms-fund-selection',
  styleUrl: 'ui-cms-fund-selection.scss',
  shadow: false,
})
export class UiCmsFundSelection {
  @Prop({ mutable: true }) body: UiCmsFundsSelectionBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  /**
   * A number to define the amount of starting suggestions
   */
  @Prop() initialAmountOfFunds: number;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  render() {
    const { fundPortraitLink, fundSearchLink } = this.body;
    const fundSearchTargetID = fundSearchLink.contentId;
    const fundPortraitTargetID = fundPortraitLink.contentId;

    return (
      <Host>
        <ui-fund-selection
          initialAmountOfFunds={this.body.initialAmountOfFunds}
          fundApi={{
            url: this.body.fundApi,
            apiKey: this.body.fundApiKey,
          }}
          fundSearchLink={{
            src: fundSearchLink?.src,
            contentID: fundSearchTargetID,
          }}
          fundPortraitLink={{
            src: fundPortraitLink?.src,
            contentID: fundPortraitTargetID,
          }}
          funds={this.body.funds}
          characteristicsByFacet={this.body.characteristicsByFacet}
          filters={this.body.filters}
          allFundsLabel={this.body.allFundsLabel}
          uniqueId={this.body.uniqueId}
        ></ui-fund-selection>
      </Host>
    );
  }
}
